import React from 'react';
import { useIntl, defineMessages } from 'react-intl-next';

import Button from '@atlaskit/button';

import { getTemplateListPage } from '@confluence/template-utils';

import { EmptyStateWrapper } from './EmptyStateWrapper';
import EmptyFeaturedImg from './EmptyFeatured.svg';

const i18n = defineMessages({
	errorHeader: {
		id: 'template-list.templates.empty.header',
		defaultMessage: 'No featured templates',
		description: 'Text that appears when there are no featured templates in the template gallery',
	},
	errorDescription: {
		id: 'template-list.templates.empty.description',
		defaultMessage:
			'Fast-track team success by promoting templates in space settings or making custom templates for your team’s unique needs.',
		description: 'Text that encourages the user to make some of their templates featured',
	},
	callToActionLink: {
		id: 'template-list.templates.empty.link',
		defaultMessage: 'Set up your templates',
		description: 'Call to action link that takes the user to the templates page list settings',
	},
});

export const EmptyFeaturedTemplates = ({ spaceKey }: { spaceKey: string }) => {
	const intl = useIntl();
	const templateListPageRoute = getTemplateListPage(spaceKey);

	return (
		<div data-testid="empty-featured-state">
			<EmptyStateWrapper
				header={intl.formatMessage(i18n.errorHeader)}
				description={intl.formatMessage(i18n.errorDescription)}
				primaryAction={
					<Button appearance="link" href={templateListPageRoute}>
						{intl.formatMessage(i18n.callToActionLink)}
					</Button>
				}
				imageUrl={EmptyFeaturedImg}
				imageHeight={180}
				maxImageWidth={220}
			/>
		</div>
	);
};
